<template lang="pug">
div.page-content
  h1.title Calculadora de Valor da Terra Nua (VTN)
  p {{ DESCRICAO }}
    el-card(shadow='hover').card-container
      validation-observer(ref='validation', tag='form')
        div.row
          div.col
            validation-provider(rules="required", v-slot="{ errors }", name="1")
              app-label(label="Município:")
              el-select.full-width.input(
                v-model='idMunicipio'
                :class="{'error' : errors.length}"
              )
                el-option(
                  v-for='municipio in municipios'
                  :key='municipio.id',
                  :label='municipio.nome'
                  :value='municipio.id'
                )
              span.help.erro {{ errors[0] }}
          div.col
            validation-provider(rules="required", v-slot="{ errors }", name="2")
              app-label.appLabel(label="Forma de pagamento:", :required="required")
              el-select(
                v-model="dadosForm.formaPagamento"
                placeholder="Selecione"
                value-key="id"
                :class="{'error' : errors.length}"
              )
                el-option(
                  v-for="formaPagamento in formaPagamentos",
                  :key="formaPagamento.id",
                  :label="formaPagamento.value",
                  :value="formaPagamento.codigo"
                )
              span.help.erro {{ errors[0] }}
          div.col
            validation-provider(rules="required", v-slot="{ errors }", name="3")
              app-label(label="Período de carência (PC):")
              el-select(
                v-model="dadosForm.carencia"
                placeholder="Selecione"
                value-key="carencia"
                :disabled="disableParcela"
                :class="{'error' : errors.length}"
              )
                el-option(
                  v-for="carencia in carencias",
                  :key="carencia.id",
                  :label="carencia.value",
                  :value="carencia.id"
                )
              span.help.erro {{ errors[0] }}
        div.row
          div.col
            validation-provider(rules="required", v-slot="{ errors }", name="4")
              app-label.appLabel(label="Área requerida (ha):", :required="required")
              app-double-input.input-redondo.appInput(
                name='Área',
                :precision="4",
                :onkeypress="onlyInputNumbers",
                v-model="vtnRequest.areaRequerida"
                :class="{'error' : errors.length}"
              )
              span.help.erro {{ errors[0] }}
          div.col
            validation-provider(rules="required", v-slot="{ errors }", name="5")
              app-label.appLabel(label="Número de parcelas anuais (n):", :required="required")
              el-select(
                v-model="dadosForm.qntdParcelas"
                placeholder="Selecione"
                value-key="id"
                :disabled="disableParcela"
                :class="{'error' : errors.length}"
              )
                el-option(
                  v-for="parcela in parcelasComputed",
                  :key="parcela.id",
                  :label="parcela.value",
                  :value="parcela.id"
                )
              span.help.erro {{ errors[0] }}
          div.col.button
            el-button.no-padding(
              type="text",
              @click="limpar"
            )    Limpar
            el-button.el-button(
              type="primary",
              @click="calcular"
            )
              i.fal.fa-credit-card
              | &nbsp Calcular
    confirmar-dados(
      v-if="dadosVtn",
      :dadosVtn="dadosVtn",
      :exibeObs="true"
    )

</template>

<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppDoubleInput from '@/components/AppDoubleInput'
import { mapActions, mapState } from 'vuex'
import AppLabel from '@/components/AppLabel.vue'
import parcelas from '@/screens/analise/vtn/constants/parcelas'
import InformarDados from '@/screens/analise/vtn/components/InformarDados.vue'
import ConfirmarDados from '@/screens/analise/vtn/components/ConfirmarDados.vue'
import TabelaAmortizacao from '@/screens/analise/vtn/components/TabelaAmortizacao.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [onlyInputNumbers, AppNotificacao],
  components: {
    AppLabel,
    AppDoubleInput,
    InformarDados,
    ConfirmarDados,
    TabelaAmortizacao
  },

  props: {
    required: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      vtnRequest: {
        areaRequerida: '',
        moduloFiscal: '',
        qtdModuloFiscal: '',
        nModuloFiscal: '',
        municipio: {
          id: '',
          nome: ''
        },
        pvtn: {
          vtnPorHaMinFormatado: ''
        }
      },
      disableParcela: false,
      idMunicipio: '',
      municipios: [],
      dadosForm: {
        formaPagamento: '',
        carencia: '',
        qntdParcelas: ''
      },
      dadosVtn: { },
      carencias: [
        {
          id: 0,
          value: 'Sem carência'
        },
        {
          id: 1,
          value: '1 Ano'
        },
        {
          id: 2,
          value: '2 Anos'
        },
        {
          id: 3,
          value: '3 Anos'
        }
      ],
      parcelas: [],
      formaPagamentos: [
        {
          id: 1,
          value: 'Parcelado',
          codigo: 'PARCELADO'
        },
        {
          id: 2,
          value: 'À vista',
          codigo: 'A_VISTA'
        }
      ]
    }
  },

  async created () {
    this.municipios = await this.findMunicipiosByUf('AP')
    this.parcelas = parcelas.parcelas
  },

  computed: {
    ...mapState({
      DESCRICAO: state => state.userInterface.dadosEstado.PUBLICO.SIMULAR_VTN.DESCRICAO
    }),
    parcelasComputed () {
      return this.parcelas.slice(0, this.parcelas.length - (this.dadosForm.carencia || 0))
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByUf: 'municipios/findMunicipiosByUf',
      findVtnById: 'vtn/findVtnById',
      createVtn: 'vtn/createVtnPublico',
      calcularVtn: 'vtn/calcularVtnPublico',
      getPvtnAtivo: 'vtn/getPvtnAtivoPublico'
    }),

    async calcular () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_SIMULAR_VTN
        )
        return
      }
      this.vtnRequest.municipio = this.municipios.filter((m) => m.id === this.idMunicipio)[0]
      const pvtn = await this.getPvtnAtivo(this.vtnRequest.municipio.id)
      this.vtnRequest.pvtn = pvtn
      this.vtnRequest.moduloFiscal = this.vtnRequest.municipio.mf
      this.vtnRequest.qtdModuloFiscal = this.vtnRequest.areaRequerida / this.vtnRequest.moduloFiscal
      this.vtnRequest.nModuloFiscal = this.vtnRequest.areaRequerida / this.vtnRequest.moduloFiscal

      this.dadosVtn = await this.createVtn(this.vtnRequest)
      this.dadosVtn.nModuloFiscal = this.dadosVtn.nModuloFiscal || this.dadosVtn.nmoduloFiscal
      this.dadosVtn.formaPagamento = this.dadosForm.formaPagamento
      this.dadosVtn.carencia = this.dadosForm.carencia
      this.dadosVtn.qntdParcelas = this.dadosForm.qntdParcelas
      this.dadosVtn.vtn = {
        id: this.dadosVtn.id
      }
      this.dadosVtn.isFinalizar = false
      this.dadosVtn.isVtnSimulado = true
    },
    limpar () {
      this.$refs.validation.reset()
      this.idMunicipio = null
      this.dadosForm.formaPagamento = null
      this.dadosForm.carencia = null
      this.vtnRequest.areaRequerida = null
      this.dadosForm.qntdParcelas = null
      this.dadosVtn = null
    }
  },
  watch: {
    'dadosForm.formaPagamento': function (newVal, oldVal) {
      if (newVal === 'A_VISTA') {
        this.dadosForm.qntdParcelas = 1
        this.dadosForm.carencia = 0
        this.disableParcela = true
      } else {
        this.disableParcela = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/_variables.scss';
  @import '@/assets/styles/element-variables.scss';

  .page-content {
    display: flex;
    flex-direction: column;
    min-height: 75vh;
  }

  .input-redondo {
    border-radius: 10px;
  }

  .error {
    border: solid 1px firebrick;
    border-radius: 10px;
  }

  .card-container {
    margin: 20px;
    border-radius: 10px;
  }

  .title {
    color: $color-primary;
  }

  .appLabel {
    flex: 1;
  }

  .appInput {
    width: 24vw;
  }

  .el-button {
    margin-top: 13%;
    margin-left: 5%;
  }

  .row {
    display: flex;
    justify-content: space-between;
  }

  .col {
    flex: 1;
  }

  .el-select {
    width: 24vw;
  }
.limpar {
  margin-right: 0px;
  color: $--color-primary;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/SimularVtn.vue